import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class PobookService {
  public token: string;

  constructor(private http: HttpClient) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  getOpportunitiesList(){
    return this.http.get(`${environment.api}pobook/oppty_list`)
  }

  getLastPONumber(){
    return this.http.get(`${environment.api}pobook/lastItem`)
  }

  getPoBook(id){
    return this.http.get(`${environment.api}pobook/item/${id}`)
  }

  getContactList(q){
    return this.http.post(`${environment.api}pobook/contacts_list`, q)
  }

  pobookInsertOrUpdate(data) {
    return this.http.post(`${environment.api}pobook/add`, data);
  }

  pobookList(data) {
    return this.http.post(`${environment.api}pobook/list`, data);
  }

  deletePoBook(id){
    return this.http.delete(`${environment.api}pobook/delete/${id}`);
  }

  insertManualUserLog(data){
    return this.http.post(`${environment.api}manualuserlog/insert`, data)
  }

  filterOppty(id) {
    return this.http.post(`${environment.api}opptynmauto`, { 'active': 1, 'business_id':id,'business_type_name':'contact'});
  }

  getAllContacts(id){
    let data = {opportunity_id: id}
    return this.http.post(`${environment.api}contact/contactmap`, data)
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/pobook.service.ts